import { render, staticRenderFns } from "./StandingsListPlayerParts.vue?vue&type=template&id=3a36e5e0&scoped=true"
import script from "./StandingsListPlayerParts.vue?vue&type=script&lang=ts"
export * from "./StandingsListPlayerParts.vue?vue&type=script&lang=ts"
import style0 from "./StandingsListPlayerParts.vue?vue&type=style&index=0&id=3a36e5e0&prod&lang=scss&scoped=true"
import style1 from "./StandingsListPlayerParts.vue?vue&type=style&index=1&id=3a36e5e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a36e5e0",
  null
  
)

export default component.exports